import { gsap, ScrollTrigger } from "../layout";

// bootstrap
import Modal from 'bootstrap/js/dist/modal';
// leaflet geojson
import indonesiaGeoJSON from '../indonesia-province-simple.json';
// swiper
import Swiper from 'swiper';
import { FreeMode, Navigation, Pagination } from 'swiper/modules';
// fancyapps
import { Fancybox } from "@fancyapps/ui";

function mapPortfolio() {
    const indonesiaMap = indonesiaGeoJSON;

    // add max bounds
    var southWest = L.latLng(8.761049185262605, 92.67377934576241),
    northEast = L.latLng(-13.090859714049843, 142.51525632284654),
    bounds = L.latLngBounds(southWest, northEast);

    let zoom, maxZoom;
    if (window.innerWidth > 1024) {
        zoom = 5;
        maxZoom = 5;
    } else {
        zoom = 4;
        maxZoom = 4;
    }

    // init
    const map = L.map('map', {
        center: [-2.569834, 118.165100],
        zoom: zoom,
        minZoom: maxZoom,
        maxZoom: 7,
        zoomControl: false,
        scrollWheelZoom: false,
        maxBounds: bounds,
    });

    // map zoom control
    L.control.zoom({
        position: 'bottomleft',
    }).addTo(map);

    // map background
    L.tileLayer('').addTo(map);

    // map style
    const style = {
        "color": "white",
        "weight": "1",
        "color": "#F2F2EF",
        "fillColor": "#00747B",
        "fillOpacity": '0.5'
    };
    const indonesiaMapGeoJSON = L.geoJSON(indonesiaGeoJSON, {
        style: style,
    }).addTo(map);

    let popupGroup = L.layerGroup();
    popupGroup.addTo(map);

    // map pin
    const customIcon = L.divIcon({
        className: 'map__marker',
        html: `<dotlottie-player src="${window.tmdrLottieSrc || ''}" class="map__lottie" background="transparent" speed="1" loop autoplay></dotlottie-player>`
    });
    
    // set location to key index mapLocationJson
    const locationMapReduce = mapLocationJson.reduce((acc, location) => {
        acc[location.location_location.toLowerCase().replace(/[ ,]+/g, '-')] = location;        
        return acc;
    }, {});

    // get modal element
    let imageModal = document.querySelector('.modal-program__image');
    let programModal = document.querySelector('.modal-program__title');
    let locationModal = document.querySelector('.modal-program__location strong');
    let statusModal = document.querySelector('.modal-program__status strong');
    let totalShelterModal = document.querySelector('.modal-program__total-shelter strong');
    let totalRangerModal = document.querySelector('.modal-program__total-ranger strong');
    let descriptionModal = document.querySelector('.modal-program__description');
    let speciesModalSection = document.querySelector('.modal-program__species');
    let speciesModal = document.querySelector('.modal-program__species-wrapper');

    // get json
    let locationMap = mapLocationJson;
    let speciesObject = speciesJson;
    
    locationMap.forEach((e) => {
        let slug = e.location_location.toLowerCase().replace(/[ ,]+/g, '-');
        let location = e.location_location;
        let latitude = e.location_latitude;
        let longitude = e.location_longitude;
        
        if(latitude && longitude != null) {
            // add marker to map
            let currentMarker = L.marker([latitude, longitude], {
                icon: customIcon,
            }).addTo(map);
        
            // events
            currentMarker.on("mouseover", (e) => {
                let myPopup = L.popup({
                    closeOnClick: false,
                    className: "custom-popup",
                    content: `<span class="map__pin ${slug}">${location}</span>`,
                }).setLatLng(e.latlng);

                myPopup.addTo(popupGroup);

                let popupContainer = document.querySelector(`.map__pin.${slug}`).parentNode.parentNode.parentNode;
                popupContainer.style.height = '56px';
                popupContainer.style.opacity = '1';
            })
            .on('mouseout', () => {
                let popupContainer = document.querySelector(`.map__pin.${slug}`).parentNode.parentNode.parentNode;
                popupContainer.style.height = '0px';
                popupContainer.style.opacity = '0';
            })
            .on('click', () => {
                const programModalBs = new Modal(document.querySelector('.modal-program'));
                programModalBs.show();

                // get selected location
                let image;
                if(locationMapReduce[slug].location_image.original_image) {
                    image = locationMapReduce[slug].location_image.original_image.url;
                }
                let program = locationMapReduce[slug].location_program;
                let location = locationMapReduce[slug].location_location;
                let status = locationMapReduce[slug].location_status;
                let totalShelter = locationMapReduce[slug].location_total_shelter;
                let totalRanger = locationMapReduce[slug].location_total_ranger;
                let description = locationMapReduce[slug].location_description;
                let species = locationMapReduce[slug].location_turtle_species;

                // passing data to modal
                imageModal.src = image ? image : 'https://dummyimage.com/525x731/#d9d8d/fff.jpg';
                programModal.innerHTML = program ? program : '-';
                locationModal.innerHTML = location ? location : '-';
                if (document.documentElement.lang === "en") {
                    status === true ? statusModal.innerHTML = 'Active' : statusModal.innerHTML = 'Inactive';
                } else if (document.documentElement.lang === "id") {
                    status === true ? statusModal.innerHTML = 'Aktif' : statusModal.innerHTML = 'Tidak Aktif';
                }
                totalShelterModal.innerHTML = totalShelter ? totalShelter : '-';
                totalRangerModal.innerHTML = totalRanger ? totalRanger : '-';
                descriptionModal.innerHTML = description ? description : '-';

                if(species) {
                    species.forEach(turtle => {
                        const turtleId = turtle.ID;
                        const image = speciesObject[turtleId].image;
                        const title = turtle.post_title;
                        
                        speciesModal.innerHTML += `
                        <div class="modal-program__species-item">
                        <img src="${image}" class="modal-program__species-image" alt="${title}">
                        <span class="modal-program__species-name">${title}</span>
                        </div>
                        `
                    });

                    speciesModalSection.classList.remove('d-none');
                } else {
                    speciesModalSection.classList.add('d-none');
                }
            })
        }
    })
    const myModalEl = document.querySelector('.modal-program')
    myModalEl.addEventListener('hidden.bs.modal', event => {
        speciesModal.innerHTML = '';
    })
    
    // nav list on mobile
    var mapSwiper = new Swiper(".map__swiper", {
        modules: [ FreeMode ],
        slidesPerView: "auto",
        spaceBetween: 8,
        freeMode: true
    });
    
    // nav button click show modal
    const mapButton = document.querySelectorAll('.map__nav-button');
    mapButton.forEach(el => {
        el.addEventListener('click', (e) => {
            let navSlug = e.target.getAttribute('data-slug');

            // get selected location
            let image;
            if(locationMapReduce[navSlug].location_image.original_image) {
                image = locationMapReduce[navSlug].location_image.original_image.url;
            }
            let program = locationMapReduce[navSlug].location_program;
            let location = locationMapReduce[navSlug].location_location;
            let status = locationMapReduce[navSlug].location_status;
            let description = locationMapReduce[navSlug].location_description;

            // passing data to modal
            imageModal.src = image ? image : 'https://dummyimage.com/525x731/#d9d8d/fff.jpg';
            programModal.innerHTML = program ? program : '-';
            locationModal.innerHTML = location ? location : '-';
            status === true ? statusModal.innerHTML = 'Aktif' : statusModal.innerHTML = 'Tidak Aktif';
            descriptionModal.innerHTML = description ? description : '-';
        })
    })
}
function mapNavResponsive() {
    let windowWidth = window.innerWidth;
    let container = document.querySelector('.map__nav .container');
    let containerWidth = container.offsetWidth;
    let containerSidePadding = window.getComputedStyle(container, null).getPropertyValue('padding-left')
    let sideGap = (windowWidth-containerWidth) / 2;
    let mapSwiper = document.querySelector('.map__swiper');
    
    mapSwiper.style.paddingLeft = `${sideGap + parseInt(containerSidePadding)}px`;
    mapSwiper.style.paddingRight = `${sideGap + parseInt(containerSidePadding)}px`;
}

function donationSection() {
    const donationSection = document.querySelector(".donation");
    const donationWrapper = document.querySelector(".donation__wrapper");

    let mm = gsap.matchMedia()
    mm.add("(min-width: 992px)", () => {
        ScrollTrigger.create({
            trigger: donationSection,
            pin: donationWrapper,
            start: "top+=5% top",
            end: "bottom-=13% bottom",
            // markers: true
        });
    })
}

function introSubProgramSection() {
    const detaiProgramSection = document.querySelector(".detail-program__info");
    const detailProgramImageContainer = document.querySelector(".detail-program__image-container");

    let mm = gsap.matchMedia()
    mm.add("(min-width: 1025px)", () => {
        ScrollTrigger.create({
            trigger: detaiProgramSection,
            pin: detailProgramImageContainer,
            start: "top top+=10%",
            end: "bottom center",
            // markers: true
        });
    })
}

function documentationSection() {
    var documentationSwiper = new Swiper(".detail-program .documentation__swiper", {
        modules: [ Navigation, Pagination ],
        slidesPerView: 1,
        spaceBetween: 12,
        navigation: {
            nextEl: ".detail-program .documentation__next",
            prevEl: ".detail-program .documentation__prev",
        },
        pagination: {
            el: ".detail-program .documentation__pagination",
            clickable: true,
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
                spaceBetween: 12,
            },
            992: {
                slidesPerView: 4,
                spaceBetween: 24,
            },
        },
    });
    var documentationSwiper = new Swiper(".documentation--yellow .documentation__swiper", {
        modules: [ Navigation, Pagination ],
        slidesPerView: 1,
        spaceBetween: 12,
        navigation: {
            nextEl: ".documentation--yellow .documentation__next",
            prevEl: ".documentation--yellow .documentation__prev",
        },
        pagination: {
            el: ".documentation--yellow .documentation__pagination",
            clickable: true,
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
                spaceBetween: 12,
            },
            992: {
                slidesPerView: 4,
                spaceBetween: 24,
            },
        },
    });
    var documentationSwiper = new Swiper(".documentation--white .documentation__swiper", {
        modules: [ Navigation, Pagination ],
        slidesPerView: 1,
        spaceBetween: 12,
        navigation: {
            nextEl: ".documentation--white .documentation__next",
            prevEl: ".documentation--white .documentation__prev",
        },
        pagination: {
            el: ".documentation--white .documentation__pagination",
            clickable: true,
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
                spaceBetween: 12,
            },
            992: {
                slidesPerView: 4,
                spaceBetween: 24,
            },
        },
    });

    // fancy box
    Fancybox.bind('[data-fancybox=documentation-gallery]', {
        // Thumbs: false,
        Toolbar: {
            display: {
                // left: [],
                // middle: [],
                right: ["close"],
            },
        },
        Images : {
        	zoom : false,
        },
        backdropClick: false
    });
    Fancybox.bind('[data-fancybox=documentation-yellow-gallery]', {
        // Thumbs: false,
        Toolbar: {
            display: {
                // left: [],
                // middle: [],
                right: ["close"],
            },
        },
        Images : {
        	zoom : false,
        },
        backdropClick: false
    });
    Fancybox.bind('[data-fancybox=documentation-white-gallery]', {
        // Thumbs: false,
        Toolbar: {
            display: {
                // left: [],
                // middle: [],
                right: ["close"],
            },
        },
        Images : {
        	zoom : false,
        },
        backdropClick: false
    });
}

function programActiveSection() {
    if(window.innerWidth > 1024) {
        const video = document.querySelector('.program-active__image-container');
        const tlVideoParallax = gsap.timeline({
        scrollTrigger: {
            trigger: '.program-active',
            scrub: true,
            pin: false,
        }
        });
        tlVideoParallax.fromTo(video, {
            yPercent: -50,
            ease: 'none'
        }, {
            yPercent: 50,
            ease: 'none'
        });
    }
    
    const capacitySection = document.querySelectorAll('.program-active');
    const items = document.querySelectorAll(".program-active__value");
    items.forEach(item => {
        const finalValueText = item.textContent.trim().replace(',', '.'); // ubah ke titik desimal JS
        const finalValue = parseFloat(finalValueText);

        gsap.fromTo(item, 
            { textContent: 0 },
            {
                textContent: finalValue,
                duration: 2,
                ease: "power1.inOut",
                onUpdate: function () {
                    const val = parseFloat(item.textContent);
                    if (finalValue % 1 !== 0) {
                        item.innerHTML = val.toFixed(2).replace('.', ',');
                    } else {
                        item.innerHTML = val.toFixed(0);
                    }
                },
                scrollTrigger: {
                    trigger: capacitySection,
                    start: "top center",
                    // markers: true,
                },
            }
        );
    });
}

let map = document.querySelector('.map');
let mapSwiper = document.querySelector('.map__swiper');
document.addEventListener('DOMContentLoaded', () => {
    if(map) {
        mapPortfolio();
        
        if(mapSwiper) {
            mapNavResponsive();
        }
    }
    donationSection();
    introSubProgramSection();
    documentationSection();
    programActiveSection();
})

window.addEventListener('resize', () => {
    if(mapSwiper) {
        mapNavResponsive();
    }
})